import loadable from '@loadable/component';
import {
  BpkBox,
  BpkBreakpoint,
  BpkSpacing,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkSectionHeader from '@skyscanner-internal/backpack-web/bpk-component-section-header';
import {
  ACTION_TYPE,
  COMPONENT_NAME,
} from '@skyscanner-internal/landing-pages-shared-constants/constants';

import logMiniEventHelper from '../../../mini-event/logMiniEventHelper';
import withErrorBoundary from '../../ErrorBoundary';
import { useMBDContext } from '../../common/MBD/useMBDContext';
import CrossLink from '../CrossLink/CrossLink';

import type { SeoCrossLinksProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';

import STYLES from './CrossLinks.module.scss';

const IntersectionObserverWrapper = loadable(
  () => import('../../IntersectionObserverWrapper/IntersectionObserverWrapper'),
);

const CrossLinks = (props: SeoCrossLinksProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();

  if (!props?.links?.length) {
    return null;
  }

  return (
    <div
      className={STYLES.CrossLinks}
      id="seo-cross-links-root"
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName)}
    >
      {props?.title && (
        <BpkBox marginBottom={BpkSpacing.SM}>
          <BpkSectionHeader
            title={props.title}
            description={props?.subtitle || ''}
          />
        </BpkBox>
      )}
      <BpkBox
        as="ul"
        padding={BpkSpacing.None}
        flexWrap="wrap"
        marginTop={{
          base: BpkSpacing.None,
          [BpkBreakpoint.SmallTablet]: BpkSpacing.MD,
        }}
      >
        {props.links.map((link, index: number) => (
          <CrossLink
            key={Object.values(link).join('-')}
            {...link}
            index={index}
          />
        ))}
      </BpkBox>
    </div>
  );
};

const CrossLinksWrapper = (props: SeoCrossLinksProps) => (
  <IntersectionObserverWrapper
    onElementSeen={() =>
      logMiniEventHelper({
        action_type: ACTION_TYPE.COMPONENT_VISIBLE,
        component_name: COMPONENT_NAME.SEO_CROSS_LINK,
      })
    }
  >
    <CrossLinks {...props} />
  </IntersectionObserverWrapper>
);

const CrossLinksWithErrorBoundary = withErrorBoundary(
  CrossLinksWrapper,
  'cross-links-component',
);

export default CrossLinksWithErrorBoundary;
